import { Product } from '@/api/skippay/gcssProducts';
import { logEvent } from '@/analytics/events';
import { SimpleProduct } from '@/sections/gcss/ProductCard';

type Category = 'main' | string | undefined;
function getItemListId({
	category,
	subcategory,
	page,
}: {
	category: Category;
	subcategory: string | undefined;
	page: number | undefined;
}): string {
	const pageNumber = page || '';
	if (category === 'main') {
		return `css_${category}_${subcategory}${pageNumber}`;
	}
	if (subcategory) {
		return `css_subcategory_list${pageNumber}`;
	}
	if (category) {
		return `css_category_list${pageNumber}`;
	}
	return `css_search_list${pageNumber}`;
}

export const logProductsEvent = (
	products: SimpleProduct[] | Product[] | undefined,
	category: Category,
	subcategory: string | undefined,
	page: number | undefined,
	type?: 'view_item_list' | 'select_item'
): void => {
	if (!products) {
		return;
	}

	const itemListId = getItemListId({ category, subcategory, page });

	const items = products?.map((product, index) => ({
		item_id: product.id,
		item_name: product.title,
		index,
		item_brand: product.brand,
		item_category: category,
		item_category2: subcategory,
		item_list_id: itemListId,
		price: product.priceAmount,
		location_id: product.merchantLink,
		discount: undefined,
		quantity: undefined,
	}));

	logEvent(type || 'view_item_list', {
		ecommerce: {
			items,
			item_list_id: itemListId,
		},
	});
};
